<template>
  <div class="payment-type">
    <div v-for="{ name, text } in options" :key="name">
      <input
        :id="name"
        v-model="paymentType"
        type="radio"
        :name="name"
        :value="name"
        class="payment-type__option"
        @change="$emit('paymentTypeChange', paymentType)"
      />
      <label class="payment-type__label" :for="name">
        <div class="payment-type__radio-handle">
          <selected-image v-if="paymentType === name" />
        </div>
        <h2 class="payment-type__text">
          {{ text }}
        </h2>
      </label>
    </div>
  </div>
</template>

<script>
import SelectedImage from "@/assets/images/selected.svg";

export default {
  name: "PaymentTypeRadio",
  components: {
    SelectedImage
  },
  data() {
    return {
      paymentType: this.$store.state.search.paymentType
    };
  },
  computed: {
    options() {
      return [
        { name: "monthly", text: this.$t("search.monthly") },
        { name: "car-price", text: this.$t("search.car-price") }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.payment-type {
  @include grid-columns(2);

  margin-bottom: 30px;

  &__option {
    display: none;

    &:checked + .payment-type__label .payment-type__radio-handle {
      border-color: transparent;
    }
  }

  &__label {
    margin-top: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__radio-handle {
    @include circle(18px);

    border: 1px solid $color-grey-100;
    margin: 0 18px 3px 0;
  }

  &__text {
    margin: 0;
  }
}

@media screen and (min-width: $media-m) {
  .payment-type {
    display: flex;
    margin-bottom: 45px;

    &__label {
      margin-right: 70px;
    }
  }
}

@media screen and (min-width: $media-l) {
  .payment-type {
    margin-left: 19px;
  }
}
</style>
